<template>
<div class="flex items-center space-x-2 mt-2">
      <label class="text-sm text-gray-300">
    Staging
    </label>
    <button
        type="button"
        :class="[
        'w-12 h-6 flex items-center rounded-full p-1 transition-colors duration-300',
        modelValue ? 'bg-green-400' : 'bg-blue-400'
        ]"
        @click="toggle"
    >
        <span
        :class="[
            'w-4 h-4 bg-white rounded-full shadow-md transform transition-transform duration-300',
            modelValue ? 'translate-x-6' : 'translate-x-0'
        ]"
        />
    </button>

    <label class="text-sm text-gray-300">
        Production
    </label>
</div>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true
  }
})
const emit = defineEmits(['update:modelValue'])

function toggle() {
  emit('update:modelValue', !props.modelValue)
}
</script>
